import React from "react";
import { Construction } from "lucide-react";

export default function Placeholder({ title, desc }) {
  return (
    <div className="animate-fade-up">
      <h1 className="font-display text-2xl font-bold text-slate-900">{title}</h1>
      <div className="mt-8 grid place-items-center rounded-2xl border border-dashed border-slate-300 bg-white py-20 text-center">
        <div className="grid h-14 w-14 place-items-center rounded-2xl bg-sky-50">
          <Construction className="h-7 w-7 text-sky-600" />
        </div>
        <h2 className="mt-4 font-display text-lg font-semibold text-slate-800">Módulo em preparação</h2>
        <p className="mt-2 max-w-md text-sm text-slate-500">{desc}</p>
        <span className="mt-4 rounded-full bg-amber-50 px-3 py-1 text-xs font-semibold text-amber-700">
          INTEGRAÇÃO PENDENTE DE CONFIGURAÇÃO
        </span>
      </div>
    </div>
  );
}
